<template>
  <div class="icon-square"></div>
</template>

<script setup>
</script>

<style scoped>

.icon-square {
  width: 58px;
  height: 58px;
  background-color: #757f88;
  margin: auto;
}
</style>
